import Rest from '../../app/Base/Rest';

/**
 * @typedef {RangeIndicatorService}
 */
export default class RangeIndicatorService extends Rest {
	/**
	 * @type {String}
	 */
	static resource = '/rangeindicator';
}
